import graph from "./index.vue";

(graph as any).install = function (Vue: any) {
  Vue.component(graph.name, graph);
};

export default graph;
